class Constants {
    public readonly HAS_APP = process.env.REACT_APP_HAS_APP === 'true';
    public readonly DEFAULT_COLOR = '#6ad9f5';
    //public readonly TINY_API_KEY = 'oanobaluzbetvxpj7of6wljtbwqjrwsorufj29fkhukiq72s';
    public readonly TINY_API_KEY = '5c1s322cky1wj1hnq8fz7s8ppgln6c3fe3jg894yqzjcmhhr';
    public readonly PLAN = 'PRO';

    constructor() { }
}

export const AppConstants = new Constants();